import axios from 'axios'
import { domains } from './config'

const baseApiAddress = `${domains.LMS_API}`

const lmsApi = (function () {
  const _api = axios.create({
    baseURL: baseApiAddress,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })

  let authInstance

  _api.interceptors.request.use(async request => {
    const token = await authInstance.getAccessTokenSilently()
    request.headers.Authorization = `Bearer ${token}`
    return request
  })

  _api.interceptors.response.use(
    response => {
      return response
    },

    error => {
      if (error.response.status === 401) {
        location.replace(window.location.origin)
      }
      return Promise.reject(error)
    },
  )

  return {
    setAuthInstance: async newAuthInstance => {
      authInstance = newAuthInstance
    },
    getLessonProgressReport: async licenseId =>
      _api.get(`/reports/license/${licenseId}`),
    getLMSTrainingStatus: async () => _api.get(`/training/me`),
    getLMSTrainingStatusCss: async learner =>
      _api.get(`/instructor/training/${encodeURIComponent(learner)}`),
    getLMSChildModuleStatus: async (learner, trackId) =>
      _api.get(
        `/instructor/training/${encodeURIComponent(learner)}/${trackId}`,
      ),
    getTrainingReport: async (learners, program) =>
      _api.post(`/reports/training/${program}`, { learners }),
    postLMSTrainingTrack: async (learner, program, moduleSco, userId) =>
      _api.post(`/instructor/training`, {
        learner,
        program,
        moduleSco,
        userId,
      }),
    putLMSTrainingTrack: async (learner, trackId, childIds, programInstance) =>
      _api.put(`/instructor/training`, {
        learner,
        trackId,
        childIds,
        programInstance,
        complete: true,
      }),
    getHistoricalSiteReports: async siteId =>
      _api.get(`/reports/archive/site-report/${siteId}`, {
        timeout: 0,
      }),
    // this is for the new K8 site reports, which are different (Excel) from the old site reports
    getK8SiteHistoricReports: async siteId =>
      _api.get(`/reports/archive/site/k8/${siteId}`, {
        timeout: 0,
      }),
  }
})()

export default lmsApi
